import STATUS from '../../shared/constants/StatusConstants';
import { GOALS_TYPE } from './goals.constants';
import { capitalize } from '../../shared/utils/strings';
import { convertArrayToHash } from '../../shared/utils/array';

export const activeBudgetVerification = goal => goal.kpi_platform.kpi === 'budget' && goal.status === 'active';

export const setGoalStatusToInactive = goals => ({
    ...goals, status: STATUS.INACTIVE,
});

export const formatGoalToEdit = newGoal => ({
    ...newGoal,
    kpi_platform_id: newGoal.kpi_platform.id,
});

export const setAllGoalBudgetAsInactive = goals => Object
    .values(goals).reduce((acc, settings) => {
        const newSettings = activeBudgetVerification(settings)
            ? setGoalStatusToInactive(settings) : settings;

        return ({ ...acc, [newSettings.id]: newSettings });
    }, {});


export const addEntityToCompanyGoals = companyId => goal => ({
    ...goal,
    entity: {
        type: GOALS_TYPE.COMPANY,
        id: companyId,
        name: 'Company Goals',
    },
});

export const addEntityToAccountGoal = account => goal => ({
    ...goal,
    entity: {
        type: GOALS_TYPE.ACCOUNT,
        id: account.id,
        name: account.name,
    },
});
export const formatOptions = value => ({
    label: capitalize(value).replace('_', ' '),
    value,
});

export const filterGoalsByEntityTypeAndEntityId = (goals, entityType, entityId) => Object.values(goals).filter((goal) => {
    if (goal.entity.type === entityType && goal.entity.id === entityId) {
        return goal;
    }
});

export const excludeGoalByEntityTypeAndEntityId = (
    goals,
    entityType,
    entityId,
) => convertArrayToHash(Object.values(goals).filter(
    goal => !(goal.entity.type === entityType && goal.entity.id === entityId),
));
